import { render, staticRenderFns } from "./editStock.vue?vue&type=template&id=20b23e8e&scoped=true&"
import script from "./editStock.vue?vue&type=script&lang=js&"
export * from "./editStock.vue?vue&type=script&lang=js&"
import style0 from "./editStock.vue?vue&type=style&index=0&id=20b23e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b23e8e",
  null
  
)

export default component.exports